/**
 * @file fileValidation.ts
 * @module Global/fileValidation
 * @description Validates uploaded file types, sizes, and metadata before frontend workflows submit files to backend storage.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import { toast } from "react-toastify";

export const fileValidation = (files: any) => {
  const MIN_FILE_SIZE = 1024; // 1MB
  const MAX_FILE_SIZE = 5120; // 5MB
  let success = true;
  const fileSizeKiloBytes = files.size / 1024;

  if (fileSizeKiloBytes > MAX_FILE_SIZE) {
    toast.error("File size is greater than maximum limit");
    success = false;

    return false;
  }
  if (!files.name.match(/\.(jpg|jpeg|png|)$/)) {
    toast.error("Please select valid image.");
    return false;
  }
  return true;
};
export const fileValidationSVG = (files: any) => {
  const MIN_FILE_SIZE = 1024; // 1MB
  const MAX_FILE_SIZE = 5120; // 5MB
  let success = true;
  const fileSizeKiloBytes = files.size / 1024;

  if (fileSizeKiloBytes > MAX_FILE_SIZE) {
    toast.error("File size is greater than maximum limit");
    success = false;

    return false;
  }
  if (!files.name.match(/\.(svg|)$/)) {
    toast.error("Please upload svg image.");
    return false;
  }
  return true;
};

export const fileValidationImageOrSvg = (files: any) => {
  const MAX_FILE_SIZE = 5120; // 5MB
  if (files.size / 1024 > MAX_FILE_SIZE) {
    toast.error("File size is greater than maximum limit");
    return false;
  }
  if (!/\.(jpg|jpeg|png|svg)$/i.test(files.name)) {
    toast.error("Please select a JPG, PNG or SVG image.");
    return false;
  }
  return true;
};
